export default __webpack_public_path__ + "static/media/nft_placeholder.2c66fc55.png";